// flag_type is a closed, fixed set of 13 values (a CHECK constraint on
// livechat_mining.flagged_threads.flag_type) — shared by the Flagged Chats report's badges/
// chips and the Agent Analysis chart so every surface uses the exact same color per type.
//
// These 13 hexes are a validated categorical palette (dataviz skill method), not reused
// brand-token shades — the brand palette only has ~6 distinct hues, and stepping within one
// hue family (4 reds, 3 greens, 2 yellows) to cover 13 flag types put visually similar colors
// right next to each other. Assigned in ALPHABETICAL flag_type order (matching the filter
// chips' order) and checked with the skill's validator against this app's dark surface
// (#0a0b10) on the *adjacent*-pair standard (the correct one for line/legend charts, per the
// skill's own chart-type table): worst adjacent CVD ΔE 9.4 (deutan/protan, target >= 8), worst
// adjacent normal-vision ΔE 17.1 (floor >= 15) — passes both with no relief needed. This is
// the documented exception to "use Tailwind tokens, not raw hex": a computed color from a
// fixed color-map constant.
export const FLAG_TYPE_HEX = {
  banned_chat: '#7ba32e',
  dead_air: '#d55181',
  escalating_sentiment: '#008300',
  escalation_threat: '#3987e5',
  missing_agent_intent: '#c94f9c',
  negative_rated: '#b06a3a',
  negative_sentiment_closure: '#9085e9',
  repeated_boilerplate: '#e66767',
  repeated_customer: '#b15fcf',
  repeated_player_question: '#199e70',
  rg_phrases: '#d95926',
  transaction_blocker: '#1a94a3',
  underage_jurisdiction_self_exclusion: '#c98500',
};
export const DEFAULT_FLAG_TYPE_HEX = '#5c6271'; // ink-mute, for any unexpected value

export const flagTypeHex = (flagType) => FLAG_TYPE_HEX[flagType] || DEFAULT_FLAG_TYPE_HEX;

// Inline style for a badge/chip: a translucent fill of the flag's color plus matching text —
// same "20% wash + solid text" look the brand's own Badge variants use, just computed instead
// of a token since these 13 hues aren't all in the token set.
export const flagTypeBadgeStyle = (flagType) => {
  const hex = flagTypeHex(flagType);
  return { backgroundColor: `${hex}33`, color: hex };
};
